export default {
  // #region : Tabs :
  currentSystemTab: null,
  SYSTEM_TABS: {
    SYSTEM: 0,
    SUBSYSTEM: 1,
    COMPONENT: 2
  },
  currentProductTab: null,
  PRODUCT_TABS: {
    LIST: 0,
    EDIT: 1
  },
  currentAttributeTab: null,
  ATTRIBUTE_TABS: {
    LIST: 0,
    EDIT: 1
  },
  // #endregion

  // #region : Loading Flags :
  userListLoading: false,
  subsystemByUserListLoading: false,
  productImagesLoading: false,
  controlTypesLoading: false,
  sellAsTypeListLoading: false,
  requirementTypesLoading: false,
  productTypesLoading: false,
  systemsLoading: false,
  subsystemsLoading: false,
  componentsLoading: false,
  productsLoading: false,
  attributesLoading: false,
  attributeValuesLoading: false,
  productAttributeValuesLoading: false,
  productAccessoriesLoading: false,
  productRequirementsLoading: false,
  productSettingsLoading: false,
  componentRequirementsLoading: false,
  componentSettingsLoading: false,
  projectSettingsLoading: false,
  productDetailsLoading: false,
  // #endregion

  // #region : Edit/Entry Dialogs :
  showEditSystemDialog: false,
  showEditSubsystemDialog: false,
  showEditComponentDialog: false,
  // #endregion

  // #region : Entity Lists :
  userList: [],
  subsystemByUserList: [],
  controlTypeList: [],
  requirementTypeList: [],
  productList: [],
  sellAsTypeList: [],
  attributeList: [],
  attributeValueList: [],
  productAccessoryList: [],
  systemList: [],
  subsystemList: [],
  componentList: [],
  productTypeList: [],
  productAttributeValueList: [],
  productRequirementList: [],
  productSettingList: [],
  componentRequirementList: [],
  componentSettingList: [],
  projectSettingList: [],
  requirementEntityList: [],
  productImageList: [],
  userTypeList: [],
  // #endregion

  // #region : Grid Selection Handling

  /*
      selected[entity]SelectionModel - used by the dataTable element as the selection model array
      selected[entity]               - the currently selected record in the selection model
   */
  selectedAttributeSelectionModel: [],
  selectedAttribute: null,
  selectedAttributeValueSelectionModel: [],
  selectedAttributeValue: null,
  selectedSystemSelectionModel: [],
  selectedSystem: null,
  selectedSubsystemSelectionModel: [],
  selectedSubsystem: null,
  selectedComponentSelectionModel: [],
  selectedComponent: null,
  selectedProductSelectionModel: [],
  selectedProduct: null,
  selectedProductAttributeValueSelectionModel: [],
  selectedProductAttributeValue: null,
  selectedProductAccessorySelectionModel: [],
  selectedProductAccessory: null,
  selectedProductRequirementSelectionModel: [],
  selectedProductRequirement: null,
  selectedProductSettingSelectionModel: [],
  selectedProductSetting: null,
  selectedComponentRequirementSelectionModel: [],
  selectedComponentRequirement: null,
  selectedComponentSettingSelectionModel: [],
  selectedComponentSetting: null,
  selectedProjectSettingSelectionModel: [],
  selectedProjectSetting: null,
  selectedProductImage: null
  // #endregion
};
